import { MapTo } from '@adobe/aem-react-editable-components';
import AppDeclined, { AppDeclinedEditConfig } from './AppDeclined';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/app-declined',
)(AppDeclined, AppDeclinedEditConfig);